import type { SystemStyleObject } from '@mui/system';
import type { Theme } from 'src/components/muiTheme/utils';

// Usage/Neutral/Header BG Secondary
export const DISABLED_AUTOMATION_SURFACE = 'background.level1';

export const disabledAutomationColors = {
  dragHandle: 'text.secondary',
  label: 'text.secondary',
  metaLabel: 'text.tertiary',
  surface: DISABLED_AUTOMATION_SURFACE,
  title: 'text.secondary',
  value: 'text.disabled',
} as const;

export const disabledAutomationRowSx: SystemStyleObject<Theme> = {
  bgcolor: disabledAutomationColors.surface,
  border: 1,
  borderColor: disabledAutomationColors.surface,
  boxShadow: 'none',
};

export const ungroupedAutomationCardSx: SystemStyleObject<Theme> = {
  bgcolor: 'background.paper',
  border: 1,
  borderColor: 'neutral.6',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
};

export const disabledAutomationCardSx: SystemStyleObject<Theme> = {
  bgcolor: 'transparent',
  boxShadow: 'none',
};

export const automationDragHighlightBg = (
  theme: Theme
): SystemStyleObject<Theme> => ({
  bgcolor: 'primary.lightest',
  ...theme.applyStyles('dark', {
    bgcolor: 'primary.4',
  }),
});

export const automationDragPlaceholderSx = (
  theme: Theme
): SystemStyleObject<Theme> => ({
  ...automationDragHighlightBg(theme),
  border: '1px dashed',
  borderColor: 'primary.main',
  borderRadius: 1,
});


export const automationPageHeaderSx = {
  mx: { xs: -2, sm: -3 },
  px: { xs: 2, sm: 3 },
} as const;

export const automationDragCardSx = (theme: Theme): SystemStyleObject<Theme> => ({
  ...automationDragHighlightBg(theme),
  boxShadow: 'none',
});
